import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-life',
  templateUrl: './student-life.component.html',
  styleUrls: ['./student-life.component.scss']
})
export class StudentLifeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
